<template>
  <div>
    <StatusBar :status="status"></StatusBar>
    <div class="photo">
      <div class="font">
        <img class="jsz1" :src="jsz1.data||require('../../assets/car_front.png')" @click.stop="showImage(jsz1.data||'')" alt />
        <p :class="jsz1.data?'hide':'show'">请拍摄本人驾驶证首页</p>
        <p class="pointText" v-if="jsz1.data">重拍<input class="retake" accept="image/*" type="file" capture="camera" data-tab="jsz1" @change.stop="imageControl"></p>
        <input v-else  accept="image/*" type="file" capture="camera" data-tab="jsz1" @change.prevent="imageControl">
      </div>
      <div class="back">
        <img class="jsz2" :src="jsz2.data||require('../../assets/car_back.png')" @click="showImage(jsz2.data||'')" alt />
        <p :class="jsz2.data?'hide':'show'">请拍摄本人驾驶证副页</p>
        <p class="pointText" v-if="jsz2.data">重拍<input class="retake" accept="image/*" type="file" capture="camera" data-tab="jsz2" @change.stop="imageControl"></p>
        <input v-else accept="image/*" type="file" capture="camera" data-tab="jsz2" @change.prevent="imageControl">
      </div>
    </div>
    <div class="tsBtnBg" @click="tsControl(true)">
      <span class="tsIcon"></span>
      <span class="tsBtn">点击查看示例</span>
    </div>

    <div class="tsBg tsdia-log" v-if="jszDiglog">
      <div class="tsContent">
         <img :src="jszDiglog" alt="">
      </div>
      <img class="closeBtn" src="../../assets/ts_close.png" alt="" @click="jszDiglog=false">
    </div>

    <div class="tsBg" v-if="tsShow">
      <div class="tsContent">
        <p>驾驶证首页</p>
        <img src="../../assets/tscar1.png" alt="">
        <p>驾驶证副页</p>
        <img src="../../assets/tscar2.png" alt="">
      </div>
      <img class="closeBtn" src="../../assets/ts_close.png" alt="" @click="tsControl(false)">
    </div>
    <p class="btn" :class="classObject" @click="nextBtnClick">下一步</p>

    <div>
      <div class="title">
        <img src="../../assets/info_left.png" alt />
        <p>拍摄示意图</p>
        <img src="../../assets/info_right.png" alt />
      </div>
      <div class="content">
        <div>
          <span>标准</span>
          <img src="../../assets/car_1standard.png" alt />
        </div>
        <div>
          <span>缺角</span>
          <img src="../../assets/car_2loss.png" alt />
        </div>
        <div>
          <span>模糊</span>
          <img src="../../assets/car_3blur.png" alt />
        </div>
        <div>
          <span>反光</span>
          <img src="../../assets/car_4reflect.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatusBar from '../../components/StatusBar'
import {uploadPic, checkDriverLicense,uploadImgUrl} from '../../utils/actions'
import {changeHistory} from '../../utils/common'
import{mapGetters} from 'vuex'
export default {
  name: 'licenceLoad',
  components: {
    StatusBar
  },
  data () {
    return {
      status: '',
      jsz1: {
        type: 1,
        uploaded: false,
        data: ''
      },
      jsz2: {
        type: 2,
        uploaded: false,
        data: ''
      },
      tsShow: false,
      jszDiglog:false,
    }
  },
  created () {
    this.status = this.$route.params.status;
    changeHistory()
  },
  methods: {
    nextBtnClick () {
      var that = this
      if (!that.jsz1.uploaded || !that.jsz2.uploaded) {
        return
      }
      checkDriverLicense({
        method: 'driver.signup.checkdriverlicense',
        id: that.userInfo.id
      }).then(function (res) {
        if (res && res.code === 0) {
          that.$router.push({name: 'msgAudit', params: {status: '8'}})
        } else {
          that.clearImage(that.jsz1)
          that.clearImage(that.jsz2)
        }
      })
    },
    clearImage (jszObj) {
       sfzObj.data = "";
       sfzObj.uploaded = false
    },
    showImage(data){
      this.jszDiglog = data;
    },
     imageControl (e) {
      let files = e.target.files || e.dataTransfer.files,
      jszType = e.target.dataset.tab;
      if (!files.length) return;
      jszType==='jsz1' ? jszType = this.jsz1 : jszType=this.jsz2;
      this.uploadPict(files[0],jszType)
    },

    /*
    1,先用图片流转化图片url
    2，拿url再校验身份证是否正确
    **/
    async uploadPict (fileData, jszType) {
      let imgUrl= await uploadImgUrl(fileData);
      if(!imgUrl) return;
      let param = {
        method:'driver.signup.upload',
        imagename: 'myImage.png',
        city_id: this.userInfo.city_id,
        id: this.userInfo.id,
        recruit_token:this.userInfo.token
      };
      jszType.type == 1 ? param.pic1_base64 = imgUrl.data : param.pic2_base64=imgUrl.data;
      let json= await uploadPic(param);
          if(!json)return;
          jszType.uploaded = true;
          jszType.data = imgUrl.data;
    },
     
    tsControl (val) {
      this.tsShow = val
    }
  },
  computed: {
    classObject () {
      if (this.jsz1.uploaded && this.jsz2.uploaded) {
        return 'opactiy'
      }
      return ''
    },
    ...mapGetters({
      userInfo:'getUserInfo'
    })
  }
}
</script>

<style lang="scss" scoped>
.photo {
  text-align: center;
  .retake{
    height: auto;
    z-index: 9999;
  }
  div {
    position: relative;
    margin: 0 auto;
  }
  img,
  input,
  div {
    width: 3.8rem;
    height: 2.12rem;
  }
  input {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
  }
  p{
    position: absolute;
    font-size: 0.24rem;
    color: #19191A;
    width: 100%;
    text-align: center;
  }
  .pointText{
    color: white;
    bottom: 0;
    opacity: 0.5;
    height: 0.48rem;
    line-height: 0.48rem;
    background: #000000;
  }
  .font {
    margin-top: 0.76rem;
    p:nth-of-type(1){
      top: 1.28rem;
    }
  }
  .back {
    margin-top: 0.3rem;
    p:nth-of-type(1){
      top: 1.2rem;
    }
  }
}
.btn {
  height: 0.92rem;
  width: 90%;
  margin-left: 5%;
  margin-top: 0.42rem;
  line-height: 0.92rem;
  text-align: center;
  opacity: 0.3;
  color: #ffffff;
  font-size: 0.3rem;
  border-radius: 0.04rem;
  background-image: linear-gradient(269deg, #F25050 0%, #C93131 100%);
}
.tsBtnBg{
  text-align: center;
  font-size: 0.24rem;
  margin-top: 0.42rem;
  margin-bottom: 0.46rem;
  .tsIcon{
    position: absolute;
    top: 6.72rem;
    left: 2.5rem;
    background: url('../../assets/bar_icon_info.png') no-repeat;
    background-size: 100%;
    width: 0.3rem;
    height: 0.3rem;
  }
  .tsBtn{
    color: #737780;
    line-height: 0.25rem;
    border-bottom: 1px solid #737780;
  }
}
.tsBg{
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 99999;
  text-align: center;
  .tsContent{
    margin: 0 auto;
    margin-top: 1.22rem;
    width: 5.6rem;
    height: 8.52rem;
    background: #FFFFFF;
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.20);
    border-radius: 0.12rem;
    overflow: hidden;
    p{
      font-size: 0.24rem;
      color: #19191A;
      margin-top: 0.26rem;
      margin-bottom: 0.1rem;
    }
    img{
      width: 5.2rem;
      height: 3.28rem;
    }
  }
  .closeBtn{
    width: 0.6rem;
    height: 0.6rem;
  }
}
.opactiy {
  opacity: 1 !important;
}

.title {
  text-align: center;
  margin-top: -0.3rem;
  img,
  p {
    display: inline-block;
  }
  img {
    width: 0.98rem;
    height: 0.12rem;
    vertical-align: 0.04rem;
  }
  p {
    font-size: 0.28rem;
    color: #323233;
    line-height: 0.24rem;
  }
}
.content {
  width: 94%;
  margin-left: 3%;
  display: flex;
  text-align: center;
  margin-top: -0.5rem;
  div {
    flex: 1;
  }
  span {
    font-size: 0.24rem;
    color: #646566;
  }
  img {
    margin-top: 0.2rem;
    width: 1.6rem;
    height: 1rem;
  }
}
.tsdia-log .tsContent{
  height:auto;
  padding-top:.1rem;
  img{
    height:auto;
    max-height:8.52rem;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/driving-licence-uploading/index.vue